import type { IconSvgObject } from './types';

const PoundSterlingIcon: IconSvgObject = [
  ["path", { d: "M10.6172 14C9.36719 16.9167 7.49219 19.8333 4.99219 21H16.8672C16.8672 21 18.7422 21 19.9922 19.8333", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9922 14H3.99219", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17.9922 8.5C17.9922 5.46243 15.5298 3 12.4922 3C9.45462 3 6.99219 5.46243 6.99219 8.5C6.99219 11.5376 9.45462 14 12.4922 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default PoundSterlingIcon;
